import React from 'react'
import Top from './Top'
import TopReviews from './Reviews'

function Details() {
  return (
<div>
    <Top/>
    <TopReviews/>
</div>
  )
}

export default Details